import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getProgramSlug } from '../../../selectors/getProgramSlug';
import { locationProviderPropsMap } from '../../../contexts/Location/locationProviderPropsMap';
import { IChallengeContext } from '../../../contexts/storage-contexts/Challenge';

export const goToParticipantPage = async ({
  challengeData,
  flowAPI,
}: {
  challengeData: IChallengeContext['challengeData'];
  flowAPI: ControllerFlowAPI;
}) => {
  const slug = getProgramSlug(challengeData?.challenge);
  if (!slug) {
    return;
  }

  const location = locationProviderPropsMap(flowAPI);

  return location.navigateToProgramPage({
    challengeId: slug,
    isParticipant: true,
  });
};
